<mat-dialog-content class="dialog-content">
  <section>
    @if (verifierGridOverrides && configurationTabs.length) {
      <div class="epd-configuration">
        <div class="epd-configuration__header">
          <div class="epd-configuration__title">
            <mds-icon
              [key]="icons.DEFAULT_PRODUCT"
              [pathColors]="[colorAliases.CONTENT_TERTIARY]"
              [width]="24"
              [height]="24"
            ></mds-icon>
            <h3>EPD Configuration</h3>
          </div>
        </div>

        @if (configurationTabs.length) {
          <mds-tab
            (activeTabChange)="configurationTabChange($event)"
            [activeTab]="activeConfigurationTab"
            [tabs]="configurationTabs"
          ></mds-tab>
        }

        @if (!configurationTabs.length || activeConfigurationTab) {
          <div>
            @if (activeConfigurationSections.length) {
              <div
                class="epd-configuration__form"
                (formValueChanged)="configurationFormValueChanged($event)"
                [form]="activeConfigurationForm"
                [lines]="activeConfigurationSections[0].lines"
                [schema]="activeConfigurationSections"
                mdsFormSchema
              ></div>
            }

            @if (shouldShowVerifierGrid()) {
              <div class="verifier-grid">
                @if (shouldShowExternalVerifierWarning()) {
                  <p class="verifier-grid__warning">{{ externalVerifierWarning }}</p>
                }

                <div class="verifier-grid__header">
                  <div class="verifier-grid__title">
                    <mds-icon
                      [key]="icons.DEFAULT_PRODUCT"
                      [pathColors]="[colorAliases.CONTENT_TERTIARY]"
                      [width]="24"
                      [height]="24"
                    ></mds-icon>
                    <h3>External Verifiers</h3>
                  </div>

                  <mds-button
                    (click)="addNewVerifier()"
                    [type]="'secondary'"
                    [icon]="icons.PLUS"
                    [iconPathColors]="[colorAliases.CONTENT_TERTIARY]"
                    [isIconLeft]="true"
                    [disabled]="!canEditVerifiers()"
                  >
                    Add new...
                  </mds-button>
                </div>

                <mds-grid
                  [minHeight]="'14rem'"
                  [overrides]="verifierGridOverrides"
                  [sizeColumnsToFit]="true"
                ></mds-grid>
              </div>
            }
          </div>
        }
      </div>
    }

    @if (epdFormSection) {
      <div
        (formValueChanged)="generalFormValueChanged($event)"
        [form]="generalForm"
        [lines]="epdSectionSchema?.lines"
        [schema]="[epdFormSection]"
        mdsFormSchema
      ></div>
    }
  </section>
</mat-dialog-content>
<mat-dialog-actions align="end" class="footer">
  <mds-button
    [type]="'primary'"
    (click)="submitEpdForm()"
    [disabled]="!epdSectionSchema?.isUpdated"
    aria-label="Update"
  >
    Update
  </mds-button>
</mat-dialog-actions>
